import React from 'react';
import styles from './Sidebar.css';

function SidebarPanelHeader({ title, closeSidebarPanel }) {
  return (
    <div className={styles.sidebarPanelHeader}>
      <span>{title}</span>
      <button title='Close Panel' onClick={closeSidebarPanel}>
        <i className='fas fa-times'></i>
      </button>
    </div>
  );
}

export default SidebarPanelHeader;
